import applogger from '@applogger'
let pageMixin
let asyncData

// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  // No-op
}
else {
  asyncData = function({ store, route, router }) {
    const __loader = () => {
      applogger.debug('page-content-type-page_content_group asyncData starting')
      return store.dispatch('node/load', {nid: route.path, cacheOptions: {scope: 'global'}})
        .then(node => {
          let loaders = []
          // Retreive the FusWS Presigned URLs for the images in the content group.
          const blobsToLoad = [
            `page-blob-top--node-${node.nid}`,
            `page-blob-bottom--node-${node.nid}`
          ]
          loaders.push(store.dispatch('blob/loadgroup', { blobIDs: blobsToLoad, filestore: 'website' }))
          const files = node.field_f_content_group_image.map(file => ([ { ...file, preset: '__original' }, { ...file, preset: '__original__lowres' } ]))
          loaders.push(store.dispatch('filestore/getFileURLBulk', { files, filestorename: 'website' }))
          return Promise.all([node, Promise.all(loaders)])
        })
        .then(([node, _loaders]) => {
          applogger.debug('page-content-type-page_content_group asyncData Complete - ' + node.title)
          return {
            itemid: node.nid,
            title: node.title
          }
        })
        .catch(err => {
          applogger.error('An error occurred loading the page.')
          switch (err.response.status) {
          case 403:
            store.commit('SET_PAGE_SETTING', { key: 'error', value: 403 })
            break
          case 404:
            store.commit('SET_PAGE_SETTING', { key: 'error', value: 404 })
            break
          default:
            store.commit('SET_PAGE_SETTING', { key: 'error', value: 500 })
            break
          }
        })
    }

    return store.dispatch('promisePool', {
      name: `content-type-page-content-group--${router.path}`,
      resolve: __loader
    })
  }

  pageMixin = {
    computed: {
      item: function() {
        const route = this.$route
        const routeParameters = route.params
        const routePath = route.path
        const routeNodeID = routeParameters.nid
        const routeHasNodeID = routeNodeID !== undefined
        const nodeIDCanBeUsed = (routeHasNodeID && !isNaN(parseFloat(routeNodeID)) && isFinite(routeNodeID))

        return (nodeIDCanBeUsed) ? this.$store.getters['node/getByNID'](routeNodeID) : this.$store.getters['node/getByPath'](routePath)
      },
      list: function() {
        const contentGroupTitles = this.item.field_t_content_group_title
        const contentGroupBodies = this.item.field_t_content_group_body
        const contentGroupImages = this.item.field_f_content_group_image
        const contentGroupLinks = this.item.field_l_content_group_link
        const contentGroupLinksExist = Object.keys(this.item).includes('field_l_content_group_link')
        const contentGroupArticlesExist = (contentGroupTitles && contentGroupTitles.length > 0)

        const buildContentArticle = (articleIndex) => ({
          title: contentGroupTitles[articleIndex],
          image: contentGroupImages[articleIndex],
          body: contentGroupBodies[articleIndex],
          link: (contentGroupLinksExist) ? contentGroupLinks[articleIndex] : null
        })

        const buildContentGroupArticles = () => contentGroupTitles.reduce((acc, contentGroupKey, loopIndex) => [...acc, buildContentArticle(loopIndex)], [])

        return (contentGroupArticlesExist) ? buildContentGroupArticles() : []
      },
      itemid: function() {
        return this.item.nid
      },
      notpublished: function() {
        return (parseInt(this.item.status) !== 1)
      },
      hasBody: function() {
        return (this.item.body && this.item.body.length > 0)
      },
      alignorient: function() {
        return this.item.field_t_content_group_img_align + ' ' + this.item.field_t_content_group_img_orient
      },
      orient: function() {
        return this.item.field_t_content_group_img_orient
      },
      hasContentHeader: function() {
        return (Object.prototype.hasOwnProperty.call(this.item, 'field_t_content_header_content') || Object.prototype.hasOwnProperty.call(this.item, 'field_t_content_header_image'))
      }
    }
  }
}

// eslint-disable-next-line no-undef
pageMixin.computed.drupalmode = () => APPSETTINGS.DataStore.store === 'drupal'
// eslint-disable-next-line no-undef
pageMixin.computed.icmsmode = () => APPSETTINGS.DataStore.store === 'ichabodcms'

export default pageMixin
export {
  asyncData,
  pageMixin
}
